import ApiService from "@/services/apiservice";
import {
  CREATE_PARTNER_MASTER,
  PARTNER_MASTER_LIST,
  DELETE_PARTNET_MASTER,
  UPDATE_PARTNET_MASTER,
  CREATE_SERVICE_CATEGORY_MASTER,
  SERVICE_CATEGORY_LIST,
  DELETE_SERVICE_CATEGORY_MASTER,
  CREATE_USER,
  DELETE_MIG_USER,
  USER_LIST,
  EDIT_PARTNER_MASTER,
  GET_PARTNER_MASTER,
  CREATE_PARTNER_SERVICE,
  PARTNER_SERVICE_LIST,
  GET_SERVICE_CATEGORY_MASTER,
  UPDATE_SERVICE_CATEGORY_MASTER,
  DELETE_PARTNER,
  GET_SERVICE_PARTNER,
  EDIT_SERVICE_PARTNER,
  UPDATE_SERVICE_PARTNER,
  QUESTIONNARIE_LIST,
  DELETE_QUESTIONNARIE,
  EDIT_QUESTIONNARIE,
  MIG_ROLES,
  GET_MIG_USER,
  EDIT_MIG_USER,
  MIG_USER_STATUS_UPDATE,
  UPDATE_PARTNER_STATUS,
  MIG_PARTNER_LIST,
  UPDATE_MIG_PARTNER_STATUS,
  UPDATE_STATUS_QUESTIONNARIE,
  GET_ALL_PARTNER_MASTER,
  PERMISSION_MENU,
  SEND_RESET_LINK,
  VALID_TOKEN,
  RESET_PASSWORD_EXISTING,
  UPDATE_STATUS_SERVICE_CATEGORY,
  ALLCATEGRY_PARTNER,
  GET_ALL_SERVICE_NO_PAGI,
  PARTNER_MAPPING,
  UPDATE_PROFILE,
  CREATE_NOTIFICATION,
  GET_MIG_USERS_COUNT,
  GET_PROFILE,
  GET_NOTIFICATION_LIST,
  GET_NOTIFICATION,
  SEND_FCM_TOKEN,
  EDIT_NOTIFICATION,
  DELETE_NOTIFICATOIN,
  CHANGE_PASSWORD,
  GET_PARTNER_BRNACH_LIST,
  SEND_NOTIFICATION_COUNT,
  UPDATE_NOIFICATION_STATUS
} from "./actions.type";
import {
  SET_PARTNER_MASTER,
  SET_SERVICE_CATEGORY_MASTER,
  SET_USER_LIST,
  SET_PARTNER_LIST,
  SET_ADMIN_LIST,
  SET_QUESTIONNARIE_LIST,
  SET_MIG_PARTNER_LIST,
  SET_PERMISSION_MENU,
  SET_NOTIFICATION_LIST,
  SET_PARTNER_BRNACH_LIST,
  SET_NOTIFICATION_COUNT
} from "./mutations.type";
import {
  _
} from "core-js";

const getDefaultState = () => {
  return {
    menuList: [],
    partnerTableList: {
      list: [],
      pageTotal: 0
    },
    migPartnerTableList: {
      list: [],
      pageTotal: 0
    },

    partnerMasterList: {
      list: [],
      pageTotal: 0
    },
    serviceCategoryMaster: {
      list: [],
      pageTotal: 0
    },
    userList: {
      list: [],
      pageTotal: 0
    },
    questionarryList: {
      list: [],
      pageTotal: 0
    },
    notificationList: {
      list: [],
      pageTotal: 0
    },
    partnerBranchList: {
      list: [],
      pageTotal: 0
    },
    notificationCount: {
      read_count: 0,
      unread_count: 0
    }
  };
};

const state = getDefaultState();

const actions = {
  async [CREATE_PARTNER_MASTER](context, payload) {
    try {
      let {
        data
      } = await ApiService.post("partner/category", payload);
      return data;
    } catch (error) {}
    return data;
  },
  async [EDIT_PARTNER_MASTER](context, payload) {
    try {
      let {
        data
      } = await ApiService.put(
        "partner/category/" + payload.id,
        payload
      );
      return data;
    } catch (error) {
      return false;
    }
  },
  async [PARTNER_MASTER_LIST](context, payload) {
    let {
      data
    } = await ApiService.get("partner/categories", payload);
    context.commit(SET_PARTNER_MASTER, data);
  },
  async [MIG_PARTNER_LIST](context, payload) {
    let {
      data
    } = await ApiService.get("partner/categories", payload);
    context.commit(SET_MIG_PARTNER_LIST, data);
  },
  async [DELETE_PARTNET_MASTER](context, payload) {
    let {
      data
    } = await ApiService.delete(
      "partner/category/" + payload.id,
      ""
    );
    return data;
  },

  [UPDATE_PARTNET_MASTER](context, payload) {
    return true;
  },
  async [CREATE_SERVICE_CATEGORY_MASTER](context, payload) {
    let {
      data
    } = await ApiService.post("service/category", payload);
    return data;
  },
  async [SERVICE_CATEGORY_LIST](context, payload) {
    let {
      data
    } = await ApiService.get("service/categories", payload);
    context.commit(SET_SERVICE_CATEGORY_MASTER, data);
  },
  async [DELETE_SERVICE_CATEGORY_MASTER](context, payload) {
    let {
      data
    } = await ApiService.delete(
      "service/category/" + payload.id,
      ""
    );
    return data;
  },
  async [CREATE_USER](context, payload) {
    let {
      data
    } = await ApiService.post("miguser", payload);
    return data;
  },
  async [USER_LIST](context, payload) {
    let {
      data
    } = await ApiService.get("migusers", payload);
    context.commit(SET_ADMIN_LIST, data);
  },
  async [DELETE_MIG_USER](context, payload) {
    let {
      data
    } = await ApiService.delete("miguser/" + payload.id, "");
    return data;
  },
  async [GET_PARTNER_MASTER](context, payload) {
    let {
      data
    } = await ApiService.get("partner/category/" + payload.id, "");

    return data;
  },
  async [GET_ALL_PARTNER_MASTER](context, payload) {
    let {
      data
    } = await ApiService.get("partner/category", "");

    return data;
  },

  async [CREATE_PARTNER_SERVICE](context, payload) {
    try {
      let {
        data
      } = await ApiService.post("partner/master", payload);

      return data;
    } catch (error) {}
    return data;
  },
  async [PARTNER_SERVICE_LIST](context, payload) {
    let {
      data
    } = await ApiService.get("partners", payload);
    context.commit(SET_PARTNER_LIST, data);
  },
  async [GET_SERVICE_CATEGORY_MASTER](context, payload) {
    let {
      data
    } = await ApiService.get(
      "service/category/" + payload.id,
      "",
      payload
    );
    return data;
  },
  async [UPDATE_SERVICE_CATEGORY_MASTER](context, payload) {
    try {
      let {
        data
      } = await ApiService.post(
        "service/category/" + payload.id,
        payload.formData
      );
      return data;
    } catch (error) {
      return false;
    }
  },
  async [GET_SERVICE_PARTNER](context, payload) {
    let {
      data
    } = await ApiService.get("partner/master/" + payload.id, "");

    return data;
  },
  async [EDIT_SERVICE_PARTNER](context, payload) {
    try {
      let {
        data
      } = await ApiService.put(
        "partner/master/" + payload.id,
        payload
      );
      return data;
    } catch (error) {
      return false;
    }
  },
  async [UPDATE_SERVICE_PARTNER](context, payload) {
    try {
      let {
        data
      } = await ApiService.patch(
        "partner/master/" + payload.id,
        payload
      );

      return data;
    } catch (error) {
      return error;
    }
  },
  async [DELETE_PARTNER](context, payload) {
    console.log("payload.id", payload.id);
    let {
      data
    } = await ApiService.delete("partner/master/" + payload.id, "");
    return data;
  },
  async [QUESTIONNARIE_LIST](context, payload) {
    let {
      data
    } = await ApiService.get("survey/masters", payload);
    context.commit(SET_QUESTIONNARIE_LIST, data);
  },
  async [DELETE_QUESTIONNARIE](context, payload) {
    let {
      data
    } = await ApiService.delete("survey/master/" + payload.id, "");
    return data;
  },
  async [EDIT_QUESTIONNARIE](context, payload) {
    try {
      let {
        data
      } = await ApiService.put(
        "survey/surveynotify/" + payload.id,
        payload
      );
      return data;
    } catch (error) {
      return false;
    }
  },
  async [MIG_ROLES](context, payload) {
    let {
      data
    } = await ApiService.get("roles/mig", payload);
    return data;
  },
  async [GET_MIG_USER](context, payload) {
    let {
      data
    } = await ApiService.get("miguser/" + payload.id, "");
    return data;
  },
  async [EDIT_MIG_USER](context, payload) {
    try {
      let {
        data
      } = await ApiService.put("miguser/" + payload.id, payload);
      return data;
    } catch (error) {
      return false;
    }
  },
  async [MIG_USER_STATUS_UPDATE](context, payload) {
    try {
      let {
        data
      } = await ApiService.patch("miguser/" + payload.id, payload);

      return data;
    } catch (error) {
      return error;
    }
  },
  async [UPDATE_MIG_PARTNER_STATUS](context, payload) {
    try {
      let {
        data
      } = await ApiService.patch("miguser/" + payload.id, payload);

      return data;
    } catch (error) {
      return error;
    }
  },
  async [UPDATE_PARTNER_STATUS](context, payload) {
    try {
      let {
        data
      } = await ApiService.patch(
        "partner/category/" + payload.id,
        payload
      );

      return data;
    } catch (error) {
      return error;
    }
  },
  async [UPDATE_STATUS_QUESTIONNARIE](context, payload) {
    try {
      let {
        data
      } = await ApiService.patch(
        "survey/surveystatus/" + payload.id,
        payload
      );

      return data;
    } catch (error) {
      return error;
    }
  },
  [PERMISSION_MENU](context, payload) {
    context.commit(SET_PERMISSION_MENU, payload);
  },
  async [SEND_RESET_LINK](context, payload) {
    let {
      data
    } = await ApiService.post("password/pcreate", payload);
    return data;
  },
  async [VALID_TOKEN](context, payload) {
    let {
      data
    } = await ApiService.get("password/find/" + payload);
    return data;
  },

  async [RESET_PASSWORD_EXISTING](context, payload) {
    let {
      data
    } = await ApiService.post("password/reset", payload);

    return data;
  },
  async [UPDATE_STATUS_SERVICE_CATEGORY](context, payload) {
    try {
      let {
        data
      } = await ApiService.patch(
        "service/category/" + payload.id,
        payload
      );

      return data;
    } catch (error) {
      return error;
    }
  },

  async [ALLCATEGRY_PARTNER](context, payload) {
    let {
      data
    } = await ApiService.get(
      "service/parent/allcategories",
      payload
    );
    return data;
  },
  async [GET_ALL_SERVICE_NO_PAGI](context, payload) {
    let {
      data
    } = await ApiService.get("service/allcategories", payload);
    return data;
  },
  async [PARTNER_MAPPING](context, payload) {
    let {
      data
    } = await ApiService.post(
      "patientdetail/partner/mapping",
      payload
    );
    return data;
  },

  async [GET_MIG_USERS_COUNT](context, payload) {
    let {
      data
    } = await ApiService.get("mig/dashboard");
    return data;
  },

  async [GET_PROFILE](context, payload) {
    let {
      data
    } = await ApiService.get("profile");
    return data;
  },

  async [UPDATE_PROFILE](context, payload) {
    let {
      data
    } = await ApiService.put("updateprofile", payload);
    return data;
  },
  async [CREATE_NOTIFICATION](context, payload) {
    let {
      data
    } = await ApiService.post("notification/create", payload);
    return data;
  },
  async [GET_NOTIFICATION_LIST](context, payload) {
    let {
      data
    } = await ApiService.get("notifications", payload);
    context.commit(SET_NOTIFICATION_LIST, data);
    return data;
  },
  async [GET_NOTIFICATION](context, payload) {
    let {
      data
    } = await ApiService.get("notification/" + payload.id, "");

    return data;
  },
  async [SEND_FCM_TOKEN](context, payload) {
    try {
      let {
        data
      } = await ApiService.put("device/token", payload);
      return data;
    } catch (error) {
      return false;
    }
  },
  async [EDIT_NOTIFICATION](context, payload) {
    try {
      let {
        data
      } = await ApiService.put(
        "notification/update/" + payload.id,
        payload
      );
      return data;
    } catch (error) {
      return false;
    }
  },
  async [DELETE_NOTIFICATOIN](context, payload) {
    try {
      let {
        data
      } = await ApiService.delete(
        "notification/delete/" + payload.id,
        ""
      );
      return data;
    } catch (error) {
      return false;
    }
  },
  async [CHANGE_PASSWORD](context, payload) {
    try {
      let {
        data
      } = await ApiService.put("changepassword", payload);
      return data;
    } catch (error) {
      return false;
    }
  },
  async [GET_PARTNER_BRNACH_LIST](context, payload) {
    let {
      data
    } = await ApiService.get("partner/branches/" + payload.id);
    context.commit(SET_PARTNER_BRNACH_LIST, data);
    return data;
  },
  async [SEND_NOTIFICATION_COUNT](context, payload) {
    let {
      data
    } = await ApiService.get("users/notifications/count");
    context.commit(SET_NOTIFICATION_COUNT, data);
    return data;
  },
  async [UPDATE_NOIFICATION_STATUS](context, payload) {
    let {
      data
    } = await ApiService.post("users/notification/update", payload);
    context.commit(SET_NOTIFICATION_COUNT, data);
    return data;
  }
};

const mutations = {
  [SET_PARTNER_MASTER](state, responce) {
    state.partnerMasterList = {
      list: _.get(responce, "categories", []),
      pageTotal: _.get(responce, "page.total", 0)
    };
    // Object.assign(state, getDefaultState())
  },
  [SET_SERVICE_CATEGORY_MASTER](state, responce) {
    state.serviceCategoryMaster = {
      list: _.get(responce, "categories", []),
      pageTotal: _.get(responce, "page.total", 0)
    };
  },
  [SET_USER_LIST](state, responce) {
    // state.partnerMasterList = responce;
  },
  [SET_PARTNER_LIST](state, responce) {
    state.partnerTableList = {
      list: _.get(responce, "partners", []),
      pageTotal: _.get(responce, "page.total", 0)
    };
  },
  [SET_MIG_PARTNER_LIST](state, response) {
    state.migPartnerTableList = {
      list: _.get(response, "categories", []),
      pageTotal: _.get(response, "page.total", 0)
    };
  },
  [SET_ADMIN_LIST](state, responce) {
    state.userList = {
      list: _.get(responce, "users", []),
      pageTotal: _.get(responce, "page.total", 0)
    };
  },
  [SET_QUESTIONNARIE_LIST](state, responce) {
    state.questionarryList = {
      list: _.get(responce, "Surveys", []),
      pageTotal: _.get(responce, "page.total", 0)
    };
  },
  [SET_PERMISSION_MENU](state, responce) {
    state.menuList = responce;
  },
  [SET_NOTIFICATION_LIST](state, responce) {
    state.notificationList = {
      list: _.get(responce, "notifications", []),
      pageTotal: _.get(responce, "page.total", 0)
    };
  },
  [SET_PARTNER_BRNACH_LIST](state, responce) {
    state.partnerBranchList = {
      list: _.get(responce, "partners", []),
      pageTotal: _.get(responce, "page.total", 0)
    };
  },
  [SET_NOTIFICATION_COUNT](state, responce) {
    state.notificationCount = {
      read_count: _.get(responce, "notifications_count.read_count", 0),
      unread_count: _.get(responce, "notifications_count.unread_count", 0)
    };
  }
};

const getters = {
  partnerMasterList(state) {
    return state.partnerMasterList;
  },
  serviceCategoryMaster(state) {
    return state.serviceCategoryMaster;
  },
  userList(state) {
    return state.userList;
  },
  partnerTableList(state) {
    return state.partnerTableList;
  },
  migPartnerTableList(state) {
    return state.migPartnerTableList;
  },
  getAdminList(state) {
    return state.userList;
  },
  questionarryList(state) {
    return state.questionarryList;
  },
  menuList(state) {
    return state.menuList;
  },
  notificationList(state) {
    return state.notificationList;
  },
  partnerBranchList(state) {
    return state.partnerBranchList;
  },
  notificationCount(state) {
    return state.notificationCount;
  }
};
export default {
  state,
  actions,
  mutations,
  getters
};